import React, { useState } from 'react';
import './Forms.css';
import axios from 'axios';

const initialFormData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: '',
};



const ContactForm = () => {
    const [formData, setFormData] = useState(initialFormData);
    const [isLoading, setIsLoading] = useState(false);
    const [submissionMessage, setSubmissionMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
    };

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    
    const payload = {
        body: JSON.stringify(formData)
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Start loading
        setSubmissionMessage(''); // Reset submission message

        try {
            const response = await axios.post('https://nxt9ft8ui5.execute-api.us-east-1.amazonaws.com/default/cecContactHandler', payload, config); // Need a new api gateway endpoint
            setSubmissionMessage('We have received your message and will be in contact as soon as possible. Thank you'); // Set success message
            setFormData(initialFormData); // Reset form data on success
        } catch (error) {
            setSubmissionMessage('Failed to submit message, please try again.'); // Set failure message
        } finally {
            setIsLoading(false); // Stop loading regardless of outcome
        }
    };

    return(
        <>
            <div className='headerTop'>
                <h2>Contact Our Team</h2>
                <p>We’re more than happy to answer any questions you have</p>
            </div>
            <div className='gh-txt'><h1>You're in good hands.</h1></div> 
            <div className='c-form'>
                <form onSubmit={handleSubmit} className='contactForm'>
                    <div className='contact-group'>
                        <label htmlFor='firstName'>First Name</label>
                        <input type='text' id="firstName" name="firstName" value={formData.firstName} required placeholder='John' onChange={handleChange} className='form-control-c'></input>
                    </div>
                    <div className='contact-group'>
                        <label htmlFor='lastName'>Last Name</label>
                        <input type='text' id="lastName" name="lastName" value={formData.lastName} required placeholder='Doe' onChange={handleChange} className='form-control-c'></input>
                    </div>
                    <div className='contact-group'>
                        <label htmlFor='email'>Email</label>
                        <input type='email' id="email" name="email" value={formData.email} required placeholder='johndoe@email.com' onChange={handleChange} className='form-control-c'></input>
                    </div>
                    <div className='contact-group'>
                        <label htmlFor='phone'>Phone (optional)</label>
                        <input type='tel' id="phone" name="phone" value={formData.phone} placeholder='+1 (888) 888-8888' onChange={handleChange} className='form-control-c'></input>
                    </div>
                    <div className='contact-group'>
                        <label htmlFor='companyName'>Company (optional)</label>
                        <input type='text' id="company" name="company" value={formData.company} placeholder='johndoe@email.com' onChange={handleChange} className='form-control-c'></input>
                    </div>
                    <div className='contact-group'>
                        <label htmlFor='subject'>Subject</label>
                        <div className='dropdown-wrap'>
                            <select id="subject" name='subject' required onChange={handleChange} className='custom-select-c form-control-c'>
                                <option value="">Select a subject</option>
                                <option value="Has a question about a service">Question about service</option>
                                <option value="Wants to submit feedback">Submit feedback</option>
                                <option value="Has a general question">General question</option>
                                <option value="Wants to schedule an appointment">Schedule an appointment</option>
                            </select>
                        </div>
                    </div>
                    <div className='contact-group-message'>
                        <label htmlFor='message'>Message</label>
                        <textarea type='text' id="message" name="message" value={formData.message} required placeholder='How can we assist you?' onChange={handleChange} className='messageBox'></textarea>
                    </div>
                    <div className='contact-group'>
                        <button 
                            type='submit' 
                            className={`submit-contact ${isLoading ? 'disabled' : ''}`}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Sending...' : 'Send Message'}
                        </button>

                        {isLoading && <div className="loading-indicator"></div>}
                    </div>
                    {submissionMessage && <div className="submission-message">{submissionMessage}</div>}
                </form>
            </div>
        </>
    );
}

export default ContactForm;